/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AccessCondition } from '../models/AccessCondition';
import { PermissionGrant } from '../models/PermissionGrant';

/**
* Role.
*/
export class Role {
  /**
  * Role ID.
  */
  'id': string;
  /**
  * Role display name.
  */
  'name': string;
  /**
  * Whether the role is a default role. If `true`, the role is a default role provided by Eon and can\'t be modified or deleted. If `false`, the role is a custom, user-created role. 
  */
  'isBuiltInRole': boolean;
  /**
  * List of permissions granted by the role.
  */
  'permissionGrants': Array<PermissionGrant>;
  /**
  * Sets of access conditions that restrict the resources a permission is granted for. IDs are set by you and are applied to the relevant permission in `permissionGrants`. An access condition can be applied to more than one permission grant. 
  */
  'accessConditions'?: Array<AccessCondition>;
  /**
  * The scopes of the role
  */
  'scopes': Array<string>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "isBuiltInRole",
      "baseName": "isBuiltInRole",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "permissionGrants",
      "baseName": "permissionGrants",
      "type": "Array<PermissionGrant>",
      "format": ""
    },
    {
      "name": "accessConditions",
      "baseName": "accessConditions",
      "type": "Array<AccessCondition>",
      "format": ""
    },
    {
      "name": "scopes",
      "baseName": "scopes",
      "type": "Array<string>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return Role.attributeTypeMap;
  }

  public constructor() {
  }
}

